export default "__VITE_ASSET__CEvRJaH___"